export var LegacyFeatureType;
(function (LegacyFeatureType) {
    LegacyFeatureType["DisabledPlugins"] = "disabled-plugins";
    LegacyFeatureType["AutoInstallPlugins"] = "auto-installed-plugins";
})(LegacyFeatureType || (LegacyFeatureType = {}));
